import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  //#region Service properties

  #snackBar = inject(MatSnackBar);
  #translateService = inject(TranslateService);

  //#endregion

  //#region Public methods

  /**
   * Displays a warning message
   *
   * @param message string to be displayed
   * @param duration message duration in ms
   *
   * @returns void
   */
  warning(message = '', duration = 3_000): void {
    this.#snackBar.open(
      message.length
        ? message
        : this.#translateService.instant('General.SomethingWentWrong'),
      this.#translateService.instant('Buttons.Close'),
      {
        panelClass: `warning-snackbar`,
        duration,
      },
    );
  }

  /**
   * Displays an error message
   *
   * @param message string to be displayed
   * @param duration message duration in ms
   *
   * @returns void
   */
  displayErrorMessage(message = '', duration = 3_000): void {
    this.#snackBar.open(
      message.length
        ? message
        : this.#translateService.instant('General.SomethingWentWrong'),
      this.#translateService.instant('Buttons.Close'),
      {
        panelClass: `error-snackbar`,
        duration,
      },
    );
  }

  /**
   * Displays a success message
   *
   * @param message string to be displayed
   * @param duration message duration in ms
   *
   * @returns void
   */
  success(message = '', duration = 3_000): void {
    this.#snackBar.open(
      message.length ? message : this.#translateService.instant('General.Done'),
      this.#translateService.instant('Buttons.Close'),
      {
        panelClass: `success-snackbar`,
        duration,
      },
    );
  }

  //#endregion
}
